export default __webpack_public_path__ + "static/media/lorenzProjection2b.af856f22.svg";